'use es6';

import { Fragment, PureComponent } from 'react';
import ThreadViewMessagePlaceholder from './ThreadViewMessagePlaceholder';
import ThreadToolbarPlaceholder from '../../thread-toolbar/components/ThreadToolbarPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ThreadViewPlaceholder extends PureComponent {
  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ThreadToolbarPlaceholder, {}), /*#__PURE__*/_jsx(ThreadViewMessagePlaceholder, {})]
    });
  }
}
ThreadViewPlaceholder.displayName = 'ThreadViewPlaceholder';